import { render, staticRenderFns } from "./PDPCommentControls.vue?vue&type=template&id=6f676226&scoped=true&"
import script from "./PDPCommentControls.vue?vue&type=script&lang=js&"
export * from "./PDPCommentControls.vue?vue&type=script&lang=js&"
import style0 from "./PDPCommentControls.vue?vue&type=style&index=0&id=6f676226&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f676226",
  null
  
)

export default component.exports